
import { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Dialog, DialogPanel } from '@headlessui/react';
import { Bars3Icon, XMarkIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { CgProfile } from 'react-icons/cg';
import Logo from '../../assets/images/gurukullogo.png';
import authService from '../../services/authService';
import { Menu } from '@headlessui/react';

import './Header.css';

const navigation = [
  { name: 'Dashboard', href: '/user/dashboard' },
  { name: 'Training', href: '/user/training' },
  { name: 'Report', href: '/user/reports' },
  { name: 'FAQ', href: '/user/faq' },

  // { name: 'Profile', href: '/user/profile' },
];

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const isHomePage = location.pathname === '/';

  const checkAuthStatus = () => {
    const authenticated = authService.isAuthenticated();
    setIsLoggedIn(authenticated);
    if (authenticated) {
      const username = authService.getUsername();
      setUserName(username || 'User');
    }
  };

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const handleLogout = async () => {
    try {
      await authService.logout();
      setIsLoggedIn(false);
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };



  return (
    <div className="bg-white">
      {/* <header className="sticky top-0 z-50"> */}
      <header className={`sticky top-0 z-50 ${isLoggedIn ? 'border-b border-gray-200' : ''}`}>
        <nav aria-label="Global" className="flex items-center justify-between p-6 lg:px-8">
          <div className="flex lg:flex-1">
            <NavLink to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Finhaat</span>
              <img alt="Logo" src={Logo} className="h-8 w-auto user-header-logo" draggable="false"/>
            </NavLink>
          </div>
          {!isHomePage && (
            <div className="hidden lg:flex lg:gap-x-12">
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={({ isActive }) =>
                    isActive
                      ? 'text-sm font-semibold leading-6 text-primary'
                      : 'text-sm font-semibold leading-6 text-gray-900'
                  }
                >
                  {item.name}
                </NavLink>
              ))}
            </div>
          )}
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            {isLoggedIn ? (
              <Menu as="div" className="relative">
                {({ open }) => (
                  <>
                    <Menu.Button
                      className="flex items-center text-gray-900"

                    >

                      {userName ? (
                        <span className="h-6 w-6 flex items-center justify-center bg-primary text-white rounded-full">
                          {userName.charAt(0).toUpperCase()}
                        </span>
                      ) : (
                        <CgProfile className="h-6 w-6" />
                      )}

                      <span className="ml-2 text-[14px] text-[#505862]">{userName.split(' ')[0]}</span>
                      <ChevronDownIcon className="h-4 w-4 ml-1" />
                    </Menu.Button>
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                      <div className="p-1 rounded-md shadow-lg ring-1 ring-gray-900/5 border border-gray-200 focus:outline-none">
                        {/* {open && (
                          <div className="px-4 py-2 text-sm font-medium text-gray-900 border-b border-gray-200">
                            {userName}
                          </div>
                        )} */}
                        <Menu.Item>
                          {({ active }) => (
                            <NavLink
                              to="/user/profile"
                              className={`block px-4 py-2 text-sm ${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'}`}
                            >
                              Profile
                            </NavLink>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              onClick={handleLogout}
                              className={`block w-full text-left px-4 py-2 text-sm ${active ? 'bg-gray-100 text-primary' : 'text-gray-700'}`}
                            >
                              Log out ➜
                            </button>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </>
                )}
              </Menu>
            ) : (
              <NavLink
                to="/login"
                className="text-sm font-semibold leading-6 text-gray-900"
              >
                Log in <span aria-hidden="true">&rarr;</span>
              </NavLink>
            )}
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>
        </nav>
        <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
          <div className="fixed inset-0 z-50" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <NavLink to="/" className="-m-1.5 p-1.5" onClick={() => setMobileMenuOpen(false)}>
                <span className="sr-only">Finhaat</span>
                {/* <img alt="Logo" src={Logo} className="h-8 w-14 finhaat-logo-mobile" /> */}
                <h2 className='finhaat-gurukul-alt'>Finhaat</h2>
              </NavLink>
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="close-menu-x-icon -m-2.5 rounded-md p-2.5 text-gray-700"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                {!isHomePage && (
                  <div className="space-y-2 py-6">
                    {navigation.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.href}
                        onClick={() => setMobileMenuOpen(false)}
                        className={({ isActive }) =>
                          isActive
                            ? '-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-[#611f69] hover:bg-gray-50'
                            : '-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50'
                        }
                      >
                        {item.name}
                      </NavLink>
                    ))}
                  </div>
                )}
                <div className="py-6 dropdown-for-mobile">
                  {isLoggedIn ? (
                    <>
                      <hr className='hr-vertical-for' />
                      <div className="py-2 text-base font-semibold leading-7 text-gray-900 border-t border-gray-500">
                        Hey, {userName} 👋
                      </div>
                      <NavLink
                        to="/user/profile"
                        onClick={() => setMobileMenuOpen(false)}
                        className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      >
                        Profile
                      </NavLink>
                      <button
                        onClick={() => {
                          setMobileMenuOpen(false);
                          handleLogout();
                        }}
                        className="-mx-3 block rounded-md text-base font-semibold leading-7 logOut-btn-mobile-view-user"
                      >
                        Log out
                      </button>
                    </>
                  ) : (
                    <NavLink
                      to="/login"
                      className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Log in
                    </NavLink>
                  )}
                </div>
              </div>
            </div>
          </DialogPanel>
        </Dialog>
      </header>
    </div>
  );
}